import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';

export const weightedCenterSelectedEntitiesSelector = (state: AppState) => state.frontendState.mapTools.weightedCenter.selectedEntities;
export const useWeightedCenterSelectedEntitiesSelector = () => useSelector(weightedCenterSelectedEntitiesSelector);

export const isWeightedCenterActiveSelector = (state: AppState) => {
  const selectedEntities = weightedCenterSelectedEntitiesSelector(state);
  return (selectedEntities.boundaries.length
    + selectedEntities.boundaryTerritories.length
    + selectedEntities.proximities.length) > 0;
};
export const useIsWeightedCenterActiveSelector = () => useSelector(isWeightedCenterActiveSelector);

const weigtedCenterResultsSelector = (state: AppState) => state.frontendState.mapTools.weightedCenter.results;
export const useWeigtedCenterResultsSelector = () => useSelector(weigtedCenterResultsSelector);

export const weightedCenterWeightColumnIdSelector = (state: AppState) => state.frontendState.mapTools.weightedCenter.weightColumnId;
export const useWeightedCenterWeightColumnIdSelector = () => useSelector(weightedCenterWeightColumnIdSelector);
